import { useQuery } from '@tanstack/react-query';

import { DASHBOARDS_KEY } from './constants';
import { getDashboardsUsageLimit } from './dashboards';

export const useGetDashboardsUsageLimit = () => {
  return useQuery({
    queryKey: [DASHBOARDS_KEY, 'UsageLimits'],
    queryFn: () => getDashboardsUsageLimit(),
  });
};
